<template>
  <div class="no-plan-banner" data-test="no-plan-banner">
    <span class="no-plan-banner__pill">DEMO</span>
    <div class="no-plan-banner__text">
      <div class="no-plan-banner__title">You're in the example project.</div>
      <div class="no-plan-banner__sub">Pick a plan to create projects and run POP on your own pages. Basic starts at {{ basicPrice }} per month.</div>
    </div>
    <template v-if="onPlansPage">
      <button type="button" class="no-plan-banner__btn no-plan-banner__btn--ghost" data-test="no-plan-free-account" @click="goToFreeAccount">Go to free account</button>
      <button type="button" class="no-plan-banner__btn" data-test="no-plan-choose-plan" @click="scrollToPlans">Choose a plan</button>
    </template>
    <router-link v-else to="/plans" class="no-plan-banner__btn" data-test="no-plan-choose-plan">Choose a plan</router-link>
  </div>
</template>

<script>
import { formatPrice, planById } from './plans'
import { segmentTrack } from '@/utils'

// Top bar of a no-plan account (user.isPlanRequired), mounted by App.vue next to the subscription bars.
// On the plan page itself the bar also carries a ghost "Go to free account" button, because the
// skip card sits below the plan cards and is out of view on most screens (tester, 2026-10-21).
export default {
  name: 'NoPlanBanner',
  computed: {
    basicPrice() {
      const basic = planById('basic')
      return formatPrice(basic && basic.prices ? basic.prices.month : 40)
    },
    onPlansPage() {
      return this.$route.name === 'Plans'
    },
    signup() {
      return this.$store.state.signup || {}
    },
  },
  methods: {
    // Same outcome as the plan page's skip card: the account opens on the dashboard, where the
    // welcome questions (the setup wizard) take over on the first visit.
    goToFreeAccount() {
      segmentTrack('plan_skipped', { fromCheckout: false, fromSignup: false, entry: this.signup.entry, source: 'banner' })
      this.$store.commit('signup/reset')
      this.$router.push('/sites')
    },
    scrollToPlans() {
      const grid = document.querySelector('.plan-page__grid')
      if (grid && grid.scrollIntoView) grid.scrollIntoView({ behavior: 'smooth', block: 'start' })
    },
  },
}
</script>

<style scoped lang="scss">
@import './auth-tokens.scss';

.no-plan-banner {
  display: flex; align-items: center; gap: 18px; flex-wrap: wrap;
  background: $pop-teal; color: #fff; padding: 12px 24px; min-height: 62px;

  &__pill { background: #ffcc00; color: $pop-teal; font-weight: 800; font-size: 11px; padding: 4px 9px; border-radius: 4px; letter-spacing: 0.04em; }
  &__text { flex: 1; min-width: 240px; }
  &__title { font-family: 'Mulish', sans-serif; font-weight: 800; font-size: 15.5px; }
  &__sub { font-size: 13px; opacity: 0.85; margin-top: 2px; }
  &__btn {
    background: $pop-accent; color: #fff !important; font: inherit; font-weight: 700; font-size: 15px; padding: 12px 22px;
    border: 1.5px solid $pop-accent; border-radius: 12px; text-decoration: none; white-space: nowrap; cursor: pointer;
    box-shadow: $auth-primary-shadow;
    &:hover { transform: translateY(-1px); }
    &--ghost {
      background: transparent; border-color: rgba(255, 255, 255, 0.85); box-shadow: none;
      &:hover { background: rgba(255, 255, 255, 0.1); border-color: #fff; }
    }
  }
}
</style>
